import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExportType } from '../../types/export';
import { Field } from '../../types/misc';
import { EndpointResponse } from '../../types/endpoints';
import type { ApiQueryParams } from '../../types/apiQuery';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (exportType: DBExportType) => {
  if (!exportType) {
    throw new Error('`exportType` is required');
  }
};

type RequestParams = Pick<ApiQueryParams, 'limit'> & {
  exportType: DBExportType;
  all?: boolean;
};

type Response = Field[];

export const getExportTypeFields = async (
  scope: RequestScope,
  { exportType, limit = 1000, all = true }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(exportType);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`${exportType}/fields?limit=${limit}&all=${all ? 1 : 0}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
